import { createAction, createErrorAction } from '@saucelabs/sl-util-redux';

import * as types from './types';

export const initialized = createAction(types.INITIALIZED);
export const cleanup = createAction(types.CLEANUP);
export const jobsRequest = createAction(types.JOBS.REQUEST);
export const jobsSuccess = createAction(types.JOBS.SUCCESS);
export const jobsFailure = createErrorAction(types.JOBS.FAILURE);
